import { render } from "./resetElecRegionDetail.vue?vue&type=template&id=4a1bd7d8&scoped=true"
import script from "./resetElecRegionDetail.vue?vue&type=script&lang=js"
export * from "./resetElecRegionDetail.vue?vue&type=script&lang=js"

import "./resetElecRegionDetail.vue?vue&type=style&index=0&id=4a1bd7d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a1bd7d8"]])

export default __exports__